
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from '../../styles/content.module.css'

import { getLayout } from '../../components/sg/Layout'
import Header from '../../components/Header'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import Link from 'next/link'
import Image from 'next/image'
import Footer from '../../components/sg/Footer'
import Cards from '../../components/sg/Cards'
import Head from 'next/head'
import { useRouter } from 'next/router'
import LangHeaders from '../../components/LangHeaders'
export default function Inflation () {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const router = useRouter()

  return (
    <>
      <Head>
        <title>用黄金储蓄保护自己免受通货膨胀的影响 - S.T.A.R. Grams账号</title>
        <meta property='og:title' key='og:title' content='用黄金储蓄保护自己免受通货膨胀的影响' />
        <meta property='og:url' key='og:url' content={router?.pathname} />
        <meta property='og:image' key='og:image' content='https://www.stargrams.app/images/og_starsavingsaccount-zh.png' />
        <meta property='og:description' key='og:description' content='让我们考虑一下导致出现这种情况的一些原因，以及为什么黄金将继续成为最安全的通货膨胀对冲工具之一。' />
        <meta property='og:type' key='og:type' content='article' />
        <meta property='og:site_name' key='og:site_name' content={t('layout-goldsaver')} />
        <meta name='title' key='title' content='用黄金储蓄保护自己免受通货膨胀的影响' />
        <meta name='description' key='description' content='让我们考虑一下导致出现这种情况的一些原因，以及为什么黄金将继续成为最安全的通货膨胀对冲工具之一。' />
        <LangHeaders {...router} withExtension />
      </Head>
      <Header showLogo />
      <div className={c('content')}>
        <div className={c('hero')}>
          <Image src='/images/goldbars.jpg' layout='fill' alt='Photo of Gold Bars' />
        </div>
        <div className={c('inner')}>
          <div className={c('single')}>
            <h3>用黄金储蓄保护自己免受通货膨胀的影响</h3>
            <br />
            <p>您可能想知道如何能够在这个通货膨胀持续上升的环境中有效的为您自身的购买能力提供保障。虽然最近政府注入的大量刺激措施可能有助于经济重新启动；但从长远的角度来看，它只能使得通胀压力上升。让我们考虑一下导致出现这种情况的一些原因，以及为什么黄金将继续成为最安全的通货膨胀对冲工具之一。</p>
            <h4>部分储备金银行系统</h4>
            <p>当我们把钱存入银行时，许多人可能认为他们的存款会被安全地置放在银行的储蓄库里，并且随时可以取出。然而，在现实生活中，情况并非如此。</p>
            <p>世界商业银行系统其实是建立在一个非常有趣的假设理论上的。 他们会认为在普遍情况下人们不太可能一次性把所有的存款都兑现，通常也的却如此。在正常情况下，银行实际上只需持有全部存款的一小部分作为手头现金，并且满足客户随时的提款需求即可。它可以用剩余的存款向企业和消费者放贷，以获取利润。银行需持有的准备金数额通常是由央行决定的，被称为储蓄金率，通常这些比值相对较低。例如，在美国一般会远低于10%。</p>
            <p>那么通货膨胀又是如何形成的呢？让我们一起思考一下并看看如何来运作以下的这个例子。假设一家银行的储备金率为10%，有人存了100美元。银行将10美元保留在准备金中，并将另外的90美元贷款给一家工业公司，然后将其存入银行账户。在这90美元的存款中，银行保留了9美元的准备金，并贷出了另外的81美元。这个过程不断重复，直到未来某个时候，我们将在最初的100美元存款中增加近1000美元的货币供应。</p>
            <p>从这个例子中我们可以看出，部分准备金使货币供应量的增长远远超过了央行所制造的基础货币。这些部分储备金的乘数效应意味着私人银行正在创造比中央银行本身更多的货币，并使货币供应量膨胀了许多倍。最近美国联邦储备局凭空创造的数万亿美元也非常令人担忧。</p>
            <h4>印钞以及通货膨胀</h4>
            <p>2020年，因为需要控制新冠病毒的蔓延，许多企业被迫停业，这也让全球的经济形势一路放缓。这也导致了世界各地的中央银行争先恐后地通过印制和分发数万亿美元的大规模刺激计划来支撑经济。</p>
            <p>在之前的量化宽松政策, 尽管大量的货币被注入了货币供应链，但因为它是通过购买美国国债直接进入银行储备的，所以对于通货膨胀的影响可以忽略不计。然而，新冠疫情之下的刺激计划主要是为了把钱送到消费者手中。试想一下，如果某人拥有一大笔资金，这一笔资金终究是会通过消费支出回到大众视野范围的经济当中的。在美国，消费者支出占总经济的三分之二。</p>
            <p>然而，新冠疫情造成了一个特殊的情况，即经济 "被迫停业"。由于企业被关闭，人们害怕感染病毒，而且外出消费的机会非常有限且极为困难。其结果是，消费者在他们是银行账户中囤积的现金达到了创纪录的水平。</p>
            <p>然而，以刺激性支票的形式大量印制货币，加上消费者们因新冠疫情原因无法像往常正常消费所导致压抑情绪，为通货膨胀创造了完美的环境。根据货币数量理论，通货膨胀是货币供应量增长和货币速度（即货币转手的速度）的一个函数。从理论上讲，货币供应量的增加应该导致价格的上涨，因为市场出现了更多的现金并同时在追求着相等水平的商品和服务。</p>
            <p>当大多数都注射了疫苗，且经济恢复正常运作后，人们在这几年被积压许久的对商品、货物以及服务的需求欲将会被完全释放出来。当市场上充斥着过多货币，而商品却无法及时生产时，商品的价格就会上升，整个市场就会出现供不应求的情况，此时便会形成通货膨胀，以及美元购买力直接下降。</p>
            <h4>美元不再受黄金支持</h4>
            <p>当美元还是由黄金标准支持的时候，这意味着人们可以用等量的黄金来赎回美元。使用此货币的人可以完全相信美元会保持其价值，并且当花费它时，它会毫无疑问地被接受。</p>
            <p>通过将美元与黄金挂钩，政府就不能无休止地印钞，因为它必须确保在其储备中持有等量的黄金。这样政府的支出就只能够限制于它能筹集到的税收或用储备金借款。然而，这种情况已经不复存在了，因为美元与黄金的挂钩早在1971年被当时的总统理查德-尼克松废除了。</p>
            <p>没有黄金的支持（或其他任何有实际价值的东西），人们对美元的信心完全是基于对它稳定性的信任。然而，背负巨额债务只会削弱美元作为世界储备货币的地位，因为国际市场对美元的需求是根据它被认定的金融实力而判断的。</p>
            <p>我们通过印钞招致的债务越多，就越会危及其地位，因为它减少了对美元作为价值储存的信心。这样的结果就是美元失去了对其他货币的购买力，以及在不确定时期作为避风港的作用。</p>
            <h4>黄作为对冲通胀的工具</h4>
            <p>您可能会问，为什么是黄金呢？因为这一贵金属的价值是直接与其稀有性挂钩的。每年只有很小一部分通过采矿所得到的黄金会进入总库存中。由于供应有限，我们看不到黄金价格大幅波动。 黄金在一般情况下都会保持其价值，它被广泛认为是一种价值储存手段。事实上，在这5000年的人文历史当中，人类一直认为黄金不仅仅是贵金属，更是一种有价值的货币，因为人们可以拿他来购买货物。</p>
            <p>黄金还起到了对冲通货膨胀的作用，因为它以美元计算的价格是可变的。如果美元因通货膨胀而贬值，黄金就会变得更加昂贵。这样一来，拥有黄金的人就受到了保护，或者说是对冲了美元下跌的影响，因为他拥有的每一盎司的黄金都会得到更多美元的补偿。</p>
            <p>在不确定的时期，黄金一直被看作是一个安全的避风港。市场从来没有像现在这样动荡不安。新冠疫情对经济带来了诸多的不确定因素。以刺激计划的形式印制数万亿美元的钞票，处于未知的领域。这种对货币供应的大量注入是否会有好结果，还有待观察。但无论结果如何，投资黄金很可能是最好的保险形式。</p>
            <h4>一个能和黄金媲美的数字解决方案</h4>
            <p>与您的银行存款不同，您在GSA账户中的黄金储蓄是100% 由存储在世界各地金库中的实物黄金所支持。每克由一克纯实物黄金支持。 这些馆藏是公开透明的，每个人都可以在 GSA 的网上探索器上看到。 最重要的是，您可以随时将您的账户余额兑换成实物黄金。</p>
            <p>使用GSA投资的客户们不仅可以从黄金价格上涨中受益，还能够保持其购买力，具有很高的便利性。 它由有形资产支持这一事实为您的储蓄提供了稳定性和可靠性，使其成为投资黄金的可行且更实用的选择。</p>
          </div>
          <div className={c('promotion')}>
            {t('banner-mission-1')}<br />
            {t('banner-mission-2')}<br />
            <br />
            <br />
            <Link href='/signup'>
              <button className='goldenshimmer' title={t('banner-signup-button-title')}>{t('banner-signup-button')}</button>
            </Link>
            <span className={c('termsnote')}>{t('banner-signup-subtext')}</span>
          </div>
        </div>
      </div>
      <Cards />
      <Footer />
    </>
  )
}

Inflation.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sg/gold-versus-inflation-zh',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  